/**
 * Linked Excel Editor Agent - Context Note Section
 * 
 * Section 4: Context engineering and ID usage
 * 
 * Explains how to use context IDs and dynamic information.
 * 
 * Keywords AI Key: LINKED_EXCEL_CONTEXT_NOTE
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { LINKED_EXCEL_PROMPT_KEYS } from './variables';

class LinkedExcelEditorContextNoteSection extends PromptSectionBase {
    protected readonly keywordsKey = LINKED_EXCEL_PROMPT_KEYS.contextNote;
    protected readonly fallbackContent = `## Context Engineering

### Dynamic Information
The prompt includes dynamic sections based on:
- **Target File**: Path, workbook ID, open/closed status
- **Workbook Context**: Auto-provided in <non_user_automated_reminder> tags
- **User Interview**: Additional tool if enabled

### Context ID Prefixes
- \`excel_*\`: Excel workbook data
- \`excelread_*\`: Read results from readExcel operations`;
}

const contextNoteSection = new LinkedExcelEditorContextNoteSection();

/**
 * Get the context note section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getContextNoteSection(): string {
    return contextNoteSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const LINKED_EXCEL_CONTEXT_NOTE = contextNoteSection.getFallbackContent();
